<div class="col-span-12">
  <div class="grid md:grid-cols-12 gap-4 p-4 md:p-6 card-bg rounded-lg duration-200 relative">
    <div class="lg:col-span-8 col-span-12 w-full relative">
      <app-cards [data]="cardsData" [valueKey]="'total_doctors'" [isClassHide]="true" [curveType]="'curveLinear'"
        [showToggle]="false" [defaultView]="'chart'" [unit]="dateRange.unit || 'day'">
      </app-cards>
   @if(isLoading()){
    <app-individual-toaster></app-individual-toaster>
    }

      <!-- <app-no-data *ngIf="!barData?.length"
            [message]="'No data available for the selected date range.'"></app-no-data> -->
    </div>

    <!-- Right Section: Stats Panel (3/12 on md+) -->
    <div
      class="lg:col-span-4 col-span-12 w-full bg-[#272D35] rounded-xl py-4 px-8 text-[#DFE5ED] shadow-sm h-[400px] relative">
      <!-- <app-loader *ngIf="contracts.businessToday.loading"></app-loader> -->
      <div class="w-full flex items-center justify-between flex-col gap-6"
        [class.blur-sm]="contracts.businessToday.loading">
        <div class="w-full">
          <div class="flex justify-start items-center gap-2">
            <h2 class="m-0 p-0 text-lg font-semibold">
              Business Registered Today
            </h2>
            <svg class="w-5 h-5 text-gray-500 hover:text-gray-400 cursor-pointer" aria-hidden="true"
              (click)="FetchBusinessToday(false)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
              viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4" />
            </svg>
          </div>
          <h2 class="text-3xl font-bold">
            {{ contracts.businessToday.total || 0 }}
          </h2>
        </div>

        <div class="w-full flex flex-col justify-between gap-3">
          <div class="flex flex-col justify-between gap-3">
            <div class="flex items-center justify-between">
              <span class="flex items-center">
                <!-- <span class="w-[10px] h-[10px] rounded-[3px] bg-[#FFBF47] mr-2"></span> -->
                Dental
              </span>
              <span class="font-semibold">{{
                contracts.businessToday.dental || 0
                }}</span>
            </div>
            <div class="bg-[#394048] h-[1px] rounded-md"></div>
          </div>
          <div class="flex flex-col justify-between gap-3">
            <div class="flex items-center justify-between">
              <span class="flex items-center">
                <!-- <span class="w-[10px] h-[10px] rounded-[3px] bg-[#3DE195] mr-2"></span> -->
                Healthcare
              </span>
              <span class="font-semibold">{{
                contracts.businessToday.healthcare || 0
                }}</span>
            </div>
            <div class="bg-[#394048] h-[1.5px] rounded-md"></div>
          </div>
          <div class="flex flex-col justify-between gap-3">
            <div class="flex items-center justify-between">
              <span class="flex items-center">
                <!-- <span class="w-[10px] h-[10px] rounded-[3px] bg-[#0C66E8] mr-2"></span> -->
                Non-Healthcare
              </span>
              <span class="font-semibold">{{
                contracts.businessToday.non_healthcare || 0
                }}</span>
            </div>
            <div class="bg-[#394048] h-[1.5px] rounded-md invisible"></div>
          </div>
        </div>
      </div>
         @if(isLoading()){
    <app-individual-toaster [loaderType]="'dark'"></app-individual-toaster>
    }
    </div>

    <div class="w-full mt-4 text-[#0c66e8] col-span-12">
      <span class="font-bold text-lg cursor-pointer" (click)="updateIndustryWiseSegregationView()">View Industry-wise
        Segregation</span>
    </div>

    <div class="col-span-12">
      <app-business-industries-stats [productServerName]="productServerName" [requiresAccessToken]="requiresAccessToken" [dateRange]="dateRange" [showComponent]="showIndustryWiseSegregation">
      </app-business-industries-stats>
    </div>
 
  </div>
</div>